"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _renderDayContents = require("./renderDayContents");

var _default = _renderDayContents.renderDayContents;
exports["default"] = _default;